import React from "react";
import { useInvestmentsId } from "@bn/api/apiv1";
import { useFundamental } from "../../hooks/useFundamental";
import { useMarketCap } from "../../hooks/useMarketCap";
import { DetailInformationBlock } from "./DetailInformationBlock";

export const DetailInformationByInvestment = ({
  investmentId,
}: {
  investmentId: number;
}) => {
  const { data: investment, isFetching } = useInvestmentsId({
    id: investmentId,
  });
  return (
    <DetailInformation
      isin={investment?.isin}
      quoteProvider={investment?.quoteProvider}
      tickerSymbol={investment?.tickerSymbol}
      currency={investment?.currency}
      isFetching={isFetching}
    />
  );
};

export const DetailInformation = ({
  quoteProvider,
  tickerSymbol,
  isin,
  currency,
  isFetching,
}: {
  quoteProvider?: string;
  tickerSymbol?: string;
  isin?: string;
  currency?: string;
  isFetching?: boolean;
}) => {
  const { data: security, isFetching: isSecurityLoading } =
    useFundamental(isin);
  const { data: marketCap, isFetching: isMarketCapLoading } = useMarketCap(
    isin,
    quoteProvider,
    tickerSymbol,
    currency
  );
  return (
    <DetailInformationBlock
      marketCap={marketCap?.marketCapitalization}
      marketCapCurrency={marketCap?.currency}
      stockIndexes={security?.stockIndexes
        ?.map(({ slug }) => slug)
        .filter((slug): slug is string => !!slug)
        .sort()}
      sectorName={security?.sector?.germanName}
      lastBalanceUpdate={security?.lastBalanceUpdate}
      wkn={security?.wkn}
      countryTwoLetterCode={security?.country?.twoLetterCode}
      countryName={security?.country?.germanName}
      isFetching={isFetching || isSecurityLoading || isMarketCapLoading}
    />
  );
};
